import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";

import { getCookie } from "typescript-cookie";
import { useAddPersonnelMutation, useDeletePersonnelMutation, useEditPersonnelMutation } from "../../../redux/api/mechanization/personnelApi";
import { EntPersonnelItem } from "../../../models/personnelItem";




const usePersonnel = (modal: any, refresh?: () => void) => {
    const { t } = useTranslation()
    const { confirm } = modal;
    const [addPersonnel] = useAddPersonnelMutation();
    const [deletePersonnel] = useDeletePersonnelMutation();
    const [editPersonnel] = useEditPersonnelMutation();

    async function onAddPersonnel(newPersonnel: EntPersonnelItem): Promise<boolean> {
        try {
            let status: boolean = false;
            await addPersonnel(newPersonnel).then((response: any) => {
                 if (response.error) {
                                  const isKyrgyz = getCookie('i18next') === 'ky';
                                  const lang = isKyrgyz ? 'kg' : 'ru';
                                  const res = response.error.data?.res;
                                  const errorMessages = Array.isArray(res)
                                      ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                      : response.error.data?.msg || t('unknownError'); 
                                  throw new Error(errorMessages);
                              }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if (refresh) refresh();
                }
            }).catch((error: any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });

            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }


    async function onDeletePersonnel(personnel: EntPersonnelItem) {
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deletePersonnel(personnel.id as number).then((response: any) => {
                        if (response.error) {
                            const isKyrgyz = getCookie('i18next') === 'ky';
                            const lang = isKyrgyz ? 'kg' : 'ru';
                            const res = response.error.data?.res;
                            const errorMessages = Array.isArray(res)
                                ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                : response.error.data?.msg || t('unknownError'); 
                            throw new Error(errorMessages);
                        }
                        if (response.data.success) {
                            status = true;
                            Modal.success({ title: t('msg.successDelete') });
                            if (refresh) refresh();
                        }
                    }).catch((error: any) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });

                    });
                }
            })
            return status
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };
    async function onEditPersonnel(editedPersonnel: EntPersonnelItem): Promise<boolean> {
        try {
            let status: boolean = false;
            await editPersonnel(editedPersonnel).then((response: any) => {
                if (response.error) {
                    const isKyrgyz = getCookie('i18next') === 'ky';
                    const lang = isKyrgyz ? 'kg' : 'ru';
                    const res = response.error.data?.res;
                    const errorMessages = Array.isArray(res)
                        ? res.map((error: any) => error[lang] || error.ru).join('\n')
                        : response.error.data?.msg || t('unknownError'); 
                    throw new Error(errorMessages);
                }
                if (response.data.success) {
                    status = true;
                    Modal.success({ title: t('msg.successEdited') });
                    if (refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };
    return { onAddPersonnel, onDeletePersonnel, onEditPersonnel }

}
export { usePersonnel };

